export enum UserMutationTypes {
  SET_TOKEN = "SET_TOKEN",
}
